export const observedWidthMixin = {
    data() {
        return {
            observedWidth: 0,
        };
    },
    mounted() {
        this.measureObservedWidth();
        if (typeof ResizeObserver === "undefined") {
            window.addEventListener("resize", this.scheduleObservedWidth);
            return;
        }
        this.widthObserver = new ResizeObserver(this.scheduleObservedWidth);
        this.widthObserver.observe(this.$el);
    },
    beforeDestroy() {
        if (this.widthObserver) this.widthObserver.disconnect();
        window.removeEventListener("resize", this.scheduleObservedWidth);
        cancelAnimationFrame(this.widthFrame);
    },
    methods: {
        scheduleObservedWidth() {
            cancelAnimationFrame(this.widthFrame);
            this.widthFrame = requestAnimationFrame(this.measureObservedWidth);
        },
        measureObservedWidth() {
            if (this.$el && this.$el.clientWidth) this.observedWidth = this.$el.clientWidth;
        },
    },
};
